// notes.ts
// Service functions for interacting with notes APIs.
// Provides retrieval and creation operations for case notes.

import { tokenAxios } from '@/utils/axios';
import { Note, GetNotesArgs, PostNoteArgs } from '@/types/notes';

/**
 * Fetches notes for a given case.
 * @param params - Parameters including practiceId and caseId
 * @returns Array of notes for the case
 */
export const getNotes = async (params: GetNotesArgs) => {
  const { data } = await tokenAxios().get<Note[]>(`/api/procedures/${params.practiceId}/${params.caseId}/notes`, {
    params,
  });
  return data;
};

/**
 * Creates a new note for a given case.
 * @param params - Parameters including practiceId, caseId, and note body
 * @returns The created note
 */
export const postNote = async (params: PostNoteArgs) => {
  const { data } = await tokenAxios().post<Note>(`/api/procedures/${params.practiceId}/${params.caseId}/notes`,
    params.body,
    {
      params,
    },
  );
  return data;
};
